export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export const safeFilename = (value: string) =>
  (value.trim() || "PhotoFolio").replace(/[<>:"/\\|?*\u0000-\u001f]/g, "-").slice(0, 80);
